import React from 'react';
import { OptionGroup } from './OptionGroup';
import { products } from '../data/products';
import type { ProductId } from '../types/treatment';
type DrugStepProps = {
  value: ProductId | null;
  onChange: (id: ProductId) => void;
  actions: React.ReactNode;
};
export function DrugStep({
  value,
  onChange,
  actions
}: DrugStepProps) {
  return <div className="flex min-h-[420px] flex-col" data-id="element-115" data-mp="3pl1w9wqlxabq">
      <h2 className="font-serif text-4xl font-normal tracking-[-0.01em] text-ink md:text-5xl" data-id="element-116" data-mp="r23gm7g0ubc4">
        Which FSH would you normally choose?
      </h2>
      <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-graphite" data-id="element-117" data-mp="m4lf324c2ye5">Select the product you would usually use for this patient.</p>

      <div className="mt-10" data-id="element-118" data-mp="cd77s8654uag">
        <OptionGroup label="FSH product" value={value} onChange={v => onChange(v as ProductId)} options={products.map(p => ({
        value: p.id,
        label: p.name,
        hint: p.id === 'other' ? 'Another FSH product' : p.molecule
      }))} data-id="element-119" data-mp="cbw6qg42y0n1" />
      </div>

      <div className="mt-auto flex items-center justify-end gap-4 pt-10" data-id="element-120" data-mp="w4hfgijvjkqe">{actions}</div>
    </div>;
}